<template>
    <vx-card title="Редактирование модели устройства" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label>Производитель</label>
                    <v-select :options="this.dicts.deviceMakers" placeholder="Выберите производителя" label="name"
                        class="w-full" v-model="form.deviceMaker">
                    </v-select>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.name" :danger="!!errors.name" :danger-text="errors.name" autocomplete="off"
                        label="Название модели" class="mt-1 w-full required" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input type="number" v-model="form.price" :danger="!!errors.price" :danger-text="errors.price"
                        autocomplete="off" label="Цена модели" class="mt-1 w-full" />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="form.isActive">Активно</vs-checkbox>
                </div>
            </div>
        </div>

        <vs-button id="submitSaveDeviceModel" class="mt-5 mr-2" color="success" @click="saveDeviceModel()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'devicemodels-edit',
    props: ['id'],
    data() {
        return {
            deviceModel: undefined,
            form: {
                isActive: undefined,
                name: undefined,
                deviceMaker: undefined,
            },
            dicts: {
                deviceMakers: [],
            },
            errors: {
                name: '',
                deviceMakerId: '',
            }
        }
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios
                .all([this.axios.get('deviceModels/dicts'), this.axios.get('deviceModels/' + this.id)])
                .then(
                    axios.spread((dicts, deviceModel) => {
                        this.dicts.deviceMakers = dicts.data.deviceMakers;
                        this.deviceModel = deviceModel.data;
                        this.form.name = deviceModel.data.name;
                        this.form.price = deviceModel.data.price;
                        this.form.deviceMaker = this.dicts.deviceMakers.find((r) => r.id === this.deviceModel.makeId);
                        this.form.isActive = deviceModel.data.active;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveDeviceModel() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                id: this.deviceModel.id,
                name: this.form.name,
                makeId: this.form.deviceMaker.id,
                price: this.form.price,
                active: this.form.isActive,
            };

            this.$axios({
                method: 'PUT',
                url: 'deviceModels/' + this.deviceModel.id,
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно обновлено",
                        text: "Модель устройства успешно сохранена",
                        color: "success",
                    });
                    this.$router.push('/deviceModels');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при обновлении модели устройства!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/deviceModels');
        }
    },
    mounted() {
        this.loadDicts();
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Редактирование устройства';
    }
}
</script>

<style>
.select-error>div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>